import Name from './button'

export default Name
